import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { BsFileEarmarkText } from "react-icons/bs";
import AccordionCard from "./AccordionCard";

function PDFDownload({ eventKey, title, subtitle, children }) {
  const [pdfLink, setPdfLink] = useState("");

  const handleOnSelect = (event) => {
    setPdfLink(event.target.value);
  };

  const handleOpenPdf = () => {
    if (!pdfLink || pdfLink === "") return;

    window.open("pdfs/" + pdfLink, "_blank", "noreferrer noopener");
  };

  return (
    <AccordionCard eventKey={eventKey} title={title} icon={BsFileEarmarkText}>
      <Form.Group
        className="row accordion-card-toggle-body"
        controlId="pdfDownloadForm"
      >
        <Form.Label className="col-12 px-2" as="h5">
          {subtitle}
        </Form.Label>
        <div className="col-md-4 p-2">
          <Form.Control as="select" onChange={handleOnSelect}>
            <option value="">Select PDF</option>
            {children}
          </Form.Control>
        </div>
        <div className="col p-2">
          <Button variant="primary" type="button" onClick={handleOpenPdf}>
            View
          </Button>
        </div>
      </Form.Group>
    </AccordionCard>
  );
}

export default PDFDownload;
